'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.News = void 0;
var $ = require("jquery");
var News = /** @class */ (function () {
    function News() {
        var _this = this;
        $('.trigNewsTab').on('click', function (e) {
            var index = $('.trigNewsTab').index(e.currentTarget);
            console.log(index);
            _this.hideNews();
            _this.openNews(index);
        });
    }
    News.prototype.hideNews = function () {
        $('.trigNewsTab').attr('data-select', '0');
        $('.bulletNewsTab').attr('data-open', 'false');
    };
    News.prototype.openNews = function (index) {
        $('.trigNewsTab').eq(index).attr('data-select', '1');
        $('.bulletNewsTab').eq(index).attr('data-open', 'true');
    };
    return News;
}());
exports.News = News;
exports.default = News;
